<style>
/*//スクロールバーを消すため*/
html {
  overflow-y: auto
}

body {
  animation: fadeIn 2s ease 0s 1 normal;
  -webkit-animation: fadeIn 2s ease 0s 1 normal;
}

/*//=====ページ遷移アニメーション*/

@keyframes fadeIn {
  0% {
    opacity: 0
  }
  100% {
    opacity: 1
  }
}

@-webkit-keyframes fadeIn {
  0% {
    opacity: 0
  }
  100% {
    opacity: 1
  }
}

/*各種グラデーション*/
.orange_gradation {
  background: linear-gradient(to right, #fa709a 0%, #fee140 100%);
}

.blue_gradation {
  background: linear-gradient(to right, #9a70fa 0%, #40e1fe 100%);
}

.puple_gradation {
  background: linear-gradient(to right, #7104cf 0%, #fAa7dB 100%);
}

.sky_gradation {
  background: linear-gradient(to right, #209cee 0%, #40e1fe 100%);
}

/*//===Vueアニメーション===*/
.v-enter-active, .v-leave-active {
  transition: opacity .5s;
}

.v-enter, .v-leave-to {
  opacity: 0;
}

/*透明度のみ*/
.opacity-leave-active,
.opacity-enter-active {
  transition: opacity 0.5s;
}

.opacity-enter {
  opacity: 0;
}

.opacity-enter-to {
  opacity: 1;
}

.opacity-leave {
  opacity: 1;
}

.opacity-leave-to {
  opacity: 0;
}

/*横方向*/
.fromLeft-leave-active,
.fromLeft-enter-active {
  /* transition: opacity 1s; */
  transition: all 0.5s;
}

.fromLeft-enter {
  opacity: 0;
  transform: translateX(-400px);
}

.fromLeft-enter-to {
  opacity: 1;
}

.fromLeft-leave {
  opacity: 1;
}

.fromLeft-leave-to {
  opacity: 0;
  transform: translateX(-400px);
}

.fromLeftToRight-leave-active,
.fromLeftToRight-enter-active {
  /* transition: opacity 1s; */
  transition: all 0.4s;
}

.fromLeftToRight-enter {
  opacity: 0;
  transform: translateX(-200px);
}

.fromLeftToRight-enter-to {
  opacity: 1;
}

.fromLeftToRight-leave {
  opacity: 1;
}

.fromLeftToRight-leave-to {
  opacity: 0;
  transform: translateX(200px);
}


/*縦方向*/
.downup-leave-active,
.downup-enter-active {
  /* transition: opacity 1s; */
  transition: all 0.5s;
}

.downup-enter {
  opacity: 0;
  transform: translateY(-50%);
}

.downup-enter-to {
  opacity: 1;
}

.downup-leave {
  opacity: 1;
}

.downup-leave-to {
  opacity: 0;
  transform: translateY(-50%);
}


.updown-leave-active,
.updown-enter-active {
  transition: all 0.5s;
}

.updown-enter {
  opacity: 0;
  transform: translateY(+50%);
}

.updown-enter-to {
  opacity: 1;
}

.updown-leave {
  opacity: 1;
}

.updown-leave-to {
  opacity: 0;
  transform: translateY(+50%);
}


.downup_length-leave-active,
.downup_length-enter-active {
  /* transition: opacity 1s; */
  transition: all 0.7s;
}

.downup_length-enter,
.downup_length-leave-to {
  opacity: 0;
  transform: translateY(-50px);
}

.downup_length-enter-to,
.downup_length-leave {
  opacity: 1;
}

/*//===アニメーション===*/

.image-input__field {
  position: relative;
  display: flex;
  background: #EEE;
  height: 80px;
  justify-content: center;
  align-items: center;
  color: #999;
  font-weight: bold;
}

.image-input__field:hover {
  background-color: #CCC;
}

.image-input__field.over {
  background-color: #CCC;
}

.image-input__field > input {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
</style>
<template>
  <v-app style="overflow-x: hidden;">
    <v-navigation-drawer v-model="drawer" :mini-variant="miniVariant" :clipped="clipped" fixed app>
      <v-list>
        <template v-for="(item, i) in items">
          <template v-if="!item.nesLogin || isSignedIn">
            <v-list-item v-if="item.url" :key="i" target="_blank" :href="item.url">
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title v-text="item.title"/>
              </v-list-item-content>
            </v-list-item>
            <v-list-item v-else :key="i" :to="item.to" router exact>
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title v-text="item.title"/>
              </v-list-item-content>
            </v-list-item>
          </template>
        </template>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar :clipped-left="clipped" fixed app dark class="secondary white--text">
      <v-app-bar-nav-icon v-if="store.showMenuBar" @click.stop="drawer = !drawer"/>
      <router-link style="height: 100%;" to="/">
        <img style="height: 100%;" class="mr-2" alt="ロケモシェア+ ロゴ" src="@/assets/ls+_b_s.png">
      </router-link>
      <v-toolbar-title v-text="title" class="pl-0"/>
      <v-spacer/>
      <template v-if="isSignedIn">
        <v-btn v-if="user" color="secondary" elevation="0" to="/login/" class="px-0">{{ user.name }}</v-btn>
        <v-btn color="white" icon @click.stop="logout">
          <v-icon>mdi-logout</v-icon>
        </v-btn>
      </template>
      <span v-else>
        <v-btn color="secondary lighten-1" to="/login/">ログイン</v-btn>
      </span>

    </v-app-bar>
    <v-main>
      <MyAlert/>
      <OverLay/>
      <router-view/>
    </v-main>
    <v-navigation-drawer v-model="rightDrawer"
                         :right="right" temporary fixed
    >
      <v-list>
        <v-list-item @click.native="right = !right">
          <v-list-item-action>
            <v-icon light>
              mdi-repeat
            </v-icon>
          </v-list-item-action>
          <v-list-item-title>Switch drawer (click me)</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-footer :absolute="false" app color="secondary"
              class="text-caption text-sm-body-2 text-md-body-1" style="overflow-x: hidden;"
    >
      <a style="text-decoration: none;" class="white--text" target="_blank" href="https://locamo.jp">&copy;合同会社ロケモAI {{ new Date().getFullYear() }}</a>
      <router-link style="text-decoration: none;" text class="white--text ml-4" to="/term/">利用規約</router-link>
      <router-link style="text-decoration: none;" text class="white--text ml-4" to="/privacy/">プライバシーポリシー</router-link>
    </v-footer>
  </v-app>
</template>

<script>
import MyAlert from "@/components/parts/MyAlert";
import OverLay from "@/components/parts/OverLay";
import firebase from "@/plugins/firebase";
import "firebase/auth";

export default {
  name: 'App',

  components: {
    MyAlert,
    OverLay,
  },
  mounted: function () {
    if (this.$route.meta.title) {
      document.title = this.$route.meta.title;
    } else {
      document.title = 'ロケモシェア＋';
    }
    if (this.$route.meta.desc) {
      // document.querySelector("meta[name='description']").setAttribute('content', this.$route.meta.desc);
    }

    console.log("app mounted");
    firebase.auth().onAuthStateChanged(user => {
      console.log("onAuthStateChanged");
      let _this = this;
      if (user && user.uid) {
        user.getIdToken(true).then(function (idToken) {
          if (_this.timer) {
            clearInterval(_this.timer);
            _this.timer = null;
          }
          _this.timer = setInterval(() => {
            user.getIdToken(/* forceRefresh */ true).then(function (idToken) {
              _this.$store.commit('onAuthStateChanged', {
                token: idToken
              });
              _this.token = idToken;
              console.log("firebase トークン更新");
            }).catch(function (error) {
              console.log("firebase トークンの更新エラー:" + error);
            });
          }, 1000 * 60 * 30);

          _this.$store.commit('onAuthStateChanged', {
            uid: user.uid,
            displayName: user.displayName,
            name: user.displayName,
            email: user.email,
            photoURL: user.photoURL,
            emailVerified: user.emailVerified,
            token: idToken
          });
          _this.$store.commit('onUserStatusChanged', true);
          _this.token = idToken;
          //ユーザデータ書き込み
          _this.getUserData(user);
          console.log("firebase トークン更新");
        }).catch(function (error) {
          console.log("firebase トークンの更新エラー:" + error);
        });
      } else {
        this.$store.commit('onAuthStateChanged', null);
        this.$store.commit('onUserStatusChanged', false);
      }
    });
  },
  data: () => ({
    token: null,
    timer: null,

    clipped: false,
    drawer: false,
    fixed: false,
    items: [
      {
        icon: 'mdi-map',
        title: 'トップ',
        to: '/',
        nesLogin: false,
        url: "",
      },
      // {
      //   icon: 'mdi-camera',
      //   title: 'シェアフォト',
      //   to: '/map/',
      //   nesLogin: false,
      // },
      // {
      //   icon: 'mdi-account',
      //   title: 'ユーザ',
      //   to: '/user',
      //   nesLogin: true,
      // },
      {
        icon: 'mdi-cog',
        title: '管理者',
        to: '/admin',
        nesLogin: true,
        url: "",
      },
      {
        icon: 'mdi-file-cancel',
        title: '利用規約',
        to: '/term',
        nesLogin: false,
        url: "",
      },
      {
        icon: 'mdi-file-document',
        title: 'プライバシーポリシー',
        to: '/privacy',
        nesLogin: false,
        url: "",
      },
      {
        icon: 'mdi-file-document-multiple',
        title: '操作説明',
        to: '',
        nesLogin: false,
        url: "https://docs.google.com/document/d/1KoFtzMixlgaJ4K0gN0IlBCR-QFT50SYHBPsVQjc_cbA/edit?usp=sharing",
      },
    ],
    miniVariant: false,
    right: true,
    rightDrawer: false,
  }),
  methods: {
    async poster(url, arr) {
      let params = new URLSearchParams();
      params.append("token", this.token);
      params.append("data", JSON.stringify(arr));
      return await this.axios.post(url, params).then(response => {
        return response.data;
      }).catch(error => {
        this.$store.commit('addMessage', {
          text: error
        });
        return false;
      });
    },
    logout: function () {
      firebase.auth().signOut().then(() => {
        this.$store.commit('addMessage', {
          text: `ログアウトしました．`,
          risk: 0
        });
        this.$router.push('/login');
      }).catch((error) => {
        this.$store.commit('addMessage', {
          text: `ログアウトに失敗しました．:${error}`,
          risk: 0
        });
      });
    },
    async getUserData(user) {
      let res = await this.poster(this.apiRoot + 'login/getUserInfo.php', {
        name: user.displayName
      });
      if (!res) {
        this.$store.commit('addMessage', {
          text: "ユーザデータの取得に失敗しました"
        });
        return;
      }
      // console.log(res);
      if (res.error == 1) {
        this.$store.commit('addMessage', {
          text: res.errormessage
        });
        return;
      }

      let _user = {
        rand: res.data.rand,
        name: res.data.name,
        permission: res.data.permission,
        image: res.data.image,
        registration: res.data.registration,
      };
      this.$store.commit('onAuthStateChanged', _user);
    },
  },
  computed: {
    user: function () {
      return this.$store.getters.user;
    },
    isSignedIn: function () {
      return this.$store.getters.isSignedIn;
    },
    title: function () {
      return this.$store.getters.get.title;
    },
    imageRoot: function () {
      return this.$store.getters.get.imageRoot;
    },
    apiRoot: function () {
      return this.$store.getters.get.apiRoot;
    },
    store: function () {
      return this.$store.getters.get;
    },
  },
};
</script>
